import { type ReactNode } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { theme } from "./index";

// Note: deliberately NOT using <CssBaseline /> here. Our app/globals.css already
// applies brand-aligned resets (body color, font-family, antialiasing). MUI's
// CssBaseline would override those at runtime via emotion-injected styles with
// higher specificity. If specific MUI components misbehave without baseline
// resets, scope a <ScopedCssBaseline> within those subtrees instead.

interface Props {
  children: ReactNode;
}

export default function ThemeProvider({ children }: Props) {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
